module.exports = __webpack_public_path__ + "img/Highlight_Feature-C.f1651b8c.png";